import { api } from "../../lib";

export interface MachineCategory {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
}

export interface CreateMachineCategoryInput {
  name: string;
  description?: string;
}

export interface UpdateMachineCategoryInput
  extends Partial<CreateMachineCategoryInput> {
  id: string;
}

export const machineCategoriesService = {
  getAll: async () => {
    return api.get<MachineCategory[]>("/admin/machine-categories");
  },

  getById: async (id: string) => {
    return api.get<MachineCategory>(`/admin/machine-categories/${id}`);
  },

  create: async (input: CreateMachineCategoryInput) => {
    return api.post<MachineCategory>("/admin/machine-categories", input);
  },

  update: async (input: UpdateMachineCategoryInput) => {
    const { id, ...updates } = input;
    return api.put<MachineCategory>(`/admin/machine-categories/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/machine-categories/${id}`);
  },
};
